import { options_premium_TransferDomain_FooterTitle } from './FAQSecOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isTransferDomainOptionHidden } from './utils/isTransferDomainOptionHidden';

var lazyFullModule = new LazyModule(() => import('./lazyFAQSecOption'));
let FAQSecOption: LazyOption = createLazyOption(
    {
        key: 'FooterSection',
        titleStringKey: options_premium_TransferDomain_FooterTitle,
        searchTermsStringKey: options_premium_TransferDomain_FooterTitle,
        hideTitleInFullOptions: false,
        isHidden: isTransferDomainOptionHidden,
    },
    lazyFullModule,
    m => m.default
);
export default FAQSecOption;
